import { render, staticRenderFns } from "./videos_home.vue?vue&type=template&id=35c0a1f7&scoped=true"
import script from "./videos_home.vue?vue&type=script&lang=js"
export * from "./videos_home.vue?vue&type=script&lang=js"
import style0 from "./videos_home.vue?vue&type=style&index=0&id=35c0a1f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c0a1f7",
  null
  
)

export default component.exports